/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResp, FieldError } from '@app/types/global.type';
import { ToastrService } from 'ngx-toastr';

export interface FormResp {
  status: boolean;
  errors: FieldError[];
}

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  errorMsg = 'Something went wrong. Please try again later.';

  constructor(
    protected http: HttpClient,
    protected toastr: ToastrService,
  ) {}

  toastError(msg?: string) {
    this.toastr.error(msg ?? this.errorMsg);
  }

  booleanResp(resp: { status: boolean; message: string }): boolean {
    if (resp.status) this.toastr.success(resp.message);
    else this.toastr.error(resp.message);

    return resp.status;
  }

  handleResp(resp: ApiResp) {
    if (resp.status) this.toastr.success(resp.message);
    else this.toastr.error(resp.message);

    return resp;
  }

  handleData(resp: ApiResp) {
    if (resp.status) this.toastr.success(resp.message);
    else this.toastr.error(resp.message);

    return resp.response;
  }

  formResp(resp: ApiResp): FormResp {
    if (resp.status) this.toastr.success(resp.message);
    else this.toastr.error(resp.message);

    return { status: resp.status, errors: resp.errors ?? [] };
  }
}
